import { createContext, useContext, useState } from "react";

interface IAudioPlayerContext {
  setActiveAudio: (audio: HTMLAudioElement | null) => void;
  activeAudio: HTMLAudioElement | null;
}

const AudioPlayerContext = createContext<IAudioPlayerContext>({
  setActiveAudio: () => {},
  activeAudio: null,
});

export const useAudioPlayerContext = () => useContext(AudioPlayerContext);

export const AudioPlayerProvider = ({ children }: { children: React.ReactNode }) => {
  const [activeAudio, setActiveAudio] = useState<HTMLAudioElement | null>(null);

  const setActive = (audio: HTMLAudioElement | null) => {
    if (activeAudio && activeAudio !== audio) {
      activeAudio.pause();
    }
    setActiveAudio(audio);
  };

  return (
    <AudioPlayerContext.Provider value={{ setActiveAudio: setActive, activeAudio }}>
      {children}
    </AudioPlayerContext.Provider>
  );
};
